import React, { useEffect, useState } from "react";
import Axios from "axios";

const Plagarism = () => {
    // const plagarismDocs = [
    //     {
    //         _id: "4389j24jkdsfdsf",
    //         value: 51,
    //         Name_of_document_one: "Name_of_document_one.docx",
    //         Name_of_document_two: "Name_of_document_two.docx",
    //     },
    //     {
    //         _id: "4389j24jkdsfds43",
    //         value: 41,
    //         Name_of_document_one: "Name_of_document_one.docx",
    //         Name_of_document_two: "Name_of_document_two.docx",
    //     },
    //     {
    //         _id: "4389j24jkdsfd535f",
    //         value: 81,
    //         Name_of_document_one: "Name_of_document_one.docx",
    //         Name_of_document_two: "Name_of_document_two.docx",
    //     },
    // ];

    const [result, setResult] = useState("");

    useEffect(() => {
        Axios.post("https://aqua-plag.herokuapp.com/plag").then((res) => {
            setResult(res.data);
            console.log(res.data);
        });
    });

    return (
        <div className="Plagarism">
            <div className="plagarism-cards">
                {result &&
                    result.map((doc, i) =>
                        doc.results.map((document, j) => (
                            <div key={i + j} className="plagarism-card">
                                <div className="plagarism-card-documents">
                                    <div className="plagarism-card-documents-doc">
                                        <strong>DOCUMENT 1 : </strong>{" "}
                                        {doc.original}
                                    </div>
                                    <div className="plagarism-card-documents-doc">
                                        <strong>DOCUMENT 2 : </strong>{" "}
                                        {document.name}
                                    </div>
                                </div>
                                <div className="plagarism-card-similarity">
                                    <div className="plagarism-card-similarity-value">
                                        {document.sim_score}%
                                    </div>
                                    <div className="plagarism-card-similarity-meter">
                                        <div
                                            className="plagarism-card-similarity-meter-fill"
                                            style={{
                                                width: `${document.sim_score}%`,
                                                background:
                                                    parseInt(
                                                        document.sim_score
                                                    ) > 50
                                                        ? "#e32c29"
                                                        : "#2deb2d",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
            </div>
        </div>
    );
};

export default Plagarism;
